import { render, staticRenderFns } from "./select.vue?vue&type=template&id=4215a6c3&"
import script from "./select.vue?vue&type=script&lang=ts&"
export * from "./select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports